/**
 * Modelo de classe para representar a estrutura do chart.
 */
export class Grafico {
    tipo: string;
    labels: any;
    values: any;
    titulo: string;
    backgroundColor: string;
    hoverBackgroundColor: string;
    config = false;
    tituloEixoY: string;
}
